import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LANGS = ["pt", "en", "fr", "es", "nl", "de", "it", "zh"];
const HREFLANG = { pt: "pt-PT", en: "en", fr: "fr", es: "es", nl: "nl", de: "de", it: "it", zh: "zh-CN" };
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://institutobarlavento.com";

function upsertMeta(selector, attrs) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs.create || {}).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", attrs.content);
}

export function useSEO({ title, description }) {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsertMeta('meta[name="description"]', { create: { name: "description" }, content: description });
      upsertMeta('meta[property="og:title"]', { create: { property: "og:title" }, content: title || document.title });
      upsertMeta('meta[property="og:description"]', { create: { property: "og:description" }, content: description });
      upsertMeta('meta[name="twitter:title"]', { create: { name: "twitter:title" }, content: title || document.title });
      upsertMeta('meta[name="twitter:description"]', { create: { name: "twitter:description" }, content: description });
      upsertMeta('meta[property="og:locale"]', { create: { property: "og:locale" }, content: (HREFLANG[i18n.language] || "pt-PT").replace("-", "_") });
    }
    // hreflang tags
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
    LANGS.forEach((lng) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = HREFLANG[lng];
      link.href = `${BASE_URL}/?lang=${lng}`;
      document.head.appendChild(link);
    });
    const xDefault = document.createElement("link");
    xDefault.rel = "alternate";
    xDefault.hreflang = "x-default";
    xDefault.href = BASE_URL;
    document.head.appendChild(xDefault);

    // canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = BASE_URL;

    // html lang
    document.documentElement.lang = HREFLANG[i18n.language] || "pt-PT";
  }, [title, description, i18n.language]);
}
